const SETTINGS_MODAL_KEY = 'pieve.settings';

export default SETTINGS_MODAL_KEY;
